import React, { Fragment } from 'react';
import HtmlComponent from './components/HtmlComponent';
import DynamicFormField from './DynamicFormField';

const FormWrapper = ({ wrapForm = false, children }) =>
  wrapForm ? (
    <form role="form" className="no-left-padding">
      {children}
    </form>
  ) : (
    children
  );

const DynamicFormFields = ({ form, fields = [], wrapForm }) => (
  <FormWrapper wrapForm={wrapForm}>
    <div>
      {(fields || [])
        .filter(({ adminHidden }) => !adminHidden)
        .map((f, i) => {
          const { html, htmlUnder } = f;
          return (
            <Fragment key={`${f.field}-${f.title}-${i}`}>
              {!!html && !htmlUnder && <HtmlComponent htmlString={html} />}
              <DynamicFormField dynamicField={f} form={form} />
              {!!html && htmlUnder && <HtmlComponent htmlString={html} />}
            </Fragment>
          );
        })}
    </div>
  </FormWrapper>
);

export default DynamicFormFields;
